import { Button } from '@ui/components/button'
import { useModal } from '@hooks/use-modal'

export const ExpiredSession = () => {
	const { close } = useModal()
	return (
		<>
			<img
				className={'carta-id__container--img'}
				src={'/assets/images/esclamativo.png'}
			/>
			<p className={'carta-id__container--title'}>Sessione Scaduta</p>
			<div style={{ padding: 20 }}>
				<p>La sessione attiva è scaduta</p>
			</div>
			<div className={'carta-id__container--btnsgrp'}>
				<Button
					label={'riprova'}
					className={'carta-id__container-btn'}
					onClick={close}
				/>
			</div>
		</>
	)
}
